import { Button, Chip, Stack } from "@mui/material";
import { CheckIcon } from "@navigations/Stepper/styles";

export type TCurrentTab = "allCandidates" | "selectedCandidates";

interface IChipsBarProps {
  currentTab: TCurrentTab;
  total: number;
  selectedCount: number;
  onChangeToAllCandidates: () => void;
  onChangeToSelected: () => void;
  onReset: () => void;
}

export const ChipsBar = ({
  currentTab,
  total,
  selectedCount,
  onChangeToAllCandidates,
  onChangeToSelected,
  onReset,
}: IChipsBarProps) => {
  return (
    <Stack
      direction="row"
      sx={(theme) => ({
        justifyContent: "space-between",
        alignItems: "center",
        py: 1,
        bgcolor: theme.palette.background.paper,
      })}
    >
      <Stack direction="row">
        <Chip
          sx={(theme) => ({ marginRight: theme.spacing(1) })}
          key="allCandidates"
          label={`Recherche de candidats (${total})`}
          onClick={onChangeToAllCandidates}
          {...(currentTab === "allCandidates" && {
            color: "primary",
            icon: <CheckIcon fontSize="small" />,
          })}
        />
        <Chip
          key="selectedCandidates"
          label={`Candidats sélectionnés (${selectedCount})`}
          onClick={onChangeToSelected}
          {...(currentTab === "selectedCandidates" && {
            color: "primary",
            icon: <CheckIcon fontSize="small" />,
          })}
        />
      </Stack>
      <Button
        onClick={onReset}
        variant="text"
        sx={{ textDecoration: "underline", "&:hover": { textDecoration: "underline" } }}
      >
        Réinitialiser
      </Button>
    </Stack>
  );
};
